export default "__VITE_ASSET__DMTbRi4R__"